module.exports = __webpack_public_path__ + "img/selectParticleIcon.0e6ccf28.png";